export default {
    permissions: 'Permissions',
    permission: 'Permission ',
    createPermissionsGroup: 'Create Permissions Group',
    permissionGroup: 'Permission Group',
    permissionGroups: 'Permission Groups',
    unitPermissions: 'Unit Permissions',
    roomPermissions: 'Room Permissions',
}